// Analytics Event Names
// {object}_{action}_{outcome}
export const ANALYTICS_EVENTS = {
  LOAN_SELECTOR_SUBMIT: 'loan_selector_submit',

  // Test Event
  TEST_EVENT: 'test_event',
};